import { Doughnut } from "react-chartjs-2";
import {
  Typography,
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  useTheme,
} from "@mui/material";
import { getColorByCount } from "../../utils/getGraphColor";

const StatusIncident = ({ data }) => {
  // const theme = useTheme();

  const dataGraph = {
    datasets: [
      {
        data: data.map((dt) => dt.countData),
        backgroundColor: getColorByCount(data.length),
        // borderWidth: 8,
        // borderColor: "#FFFFFF",
        // hoverBorderColor: "#FFFFFF",
      },
    ],
    labels: data.map((dt) => dt.groupName),
  };

  const options = {
    weight: 0.4,
    cutout: 40,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        intersect: false,
        mode: "index",
      },
    },
  };

  return (
    <Card>
      <Typography textAlign={"center"} variant="body1" marginTop={3}>
        Status Incident
      </Typography>
      <CardContent>
        <Box
          sx={{
            height: 150,
            maxHeight: "100%",
            position: "relative",
          }}
        >
          <Doughnut data={dataGraph} options={options} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatusIncident;
